import { GQLProductFragment, GQLSizeFragment } from '@theprintbar/graphql';
import { cn, getSortedSizes } from '@theprintbar/shared';

interface ProductSizeBubblesProps {
	product: GQLProductFragment;
	colourCode?: string;
	onlySameday?: boolean;
}

export function ProductSizeBubble({ className, size, quantity }: { className?: string; size: GQLSizeFragment; quantity?: number }) {
	return (
		<div className={cn('text-center py-1 rounded-full border transition', className)}>
			<h5 className="text-xs">
				{quantity ? `${quantity}x ` : ''}
				{size.code}
			</h5>
		</div>
	);
}
export function ProductSizeBubbles({ product, colourCode, onlySameday }: ProductSizeBubblesProps) {
	const allSizes = getSortedSizes(product).filter(s => !onlySameday || s.sameday);
	const colourSizes = getSortedSizes(product, colourCode).filter(s => !onlySameday || s.sameday);

	return (
		<div className="flex flex-wrap gap-2">
			{allSizes.map(({ variant }) => (
				<ProductSizeBubble
					key={variant.size.code}
					size={variant.size}
					className={cn(
						'w-10',
						!!colourSizes.find(s => s.variant.size.code === variant.size.code)
							? 'border-blue text-blue'
							: 'border-grey opacity-80 text-grey line-through',
					)}
				/>
			))}
		</div>
	);
}
